import { BLACKFRIDAY_PRE_START_DATE, BLACKFRIDAY_START_DATE, BLACKFRIDAY_POST_START_DATE, CYBERMONDAY_START_DATE } from "@Constants/env";

const ONE_SECOND = 1000;
const ONE_DAY = 24 * 60 * 60 * 1000;

const BFCM_PRE_START = new Date(BLACKFRIDAY_PRE_START_DATE || "Nov 18, 2024 00:00:00").getTime();
const BFCM_BF_START = new Date(BLACKFRIDAY_START_DATE || "Nov 25, 2024 00:00:00").getTime();
const BFCM_POSTBF_START = new Date(BLACKFRIDAY_POST_START_DATE || "Nov 30, 2024 00:00:00").getTime();
const BFCM_CM_START = new Date(CYBERMONDAY_START_DATE || "Dec 02, 2024 00:00:00").getTime();

const BFCM_PRE_END = BFCM_BF_START - ONE_SECOND;
const BFCM_BF_END = BFCM_POSTBF_START - ONE_SECOND;
const BFCM_POSTBF_END = BFCM_CM_START - ONE_SECOND;
const BFCM_CM_END = BFCM_CM_START + ONE_DAY - ONE_SECOND;

export default {
  state: {
    // User Local-Time
    bfcmDateNow: undefined,

    // Week Before BFCM (Monday to Sunday)
    bfcmPreStart: BFCM_PRE_START,
    bfcmPreEnd: BFCM_PRE_END,

    // BF Promo Week (Monday to Thursday)
    bfcmBfStart: BFCM_BF_START,
    bfcmBfEnd: BFCM_BF_END,

    // BF Promo Week (Friday to Sunday)
    bfcmPostBfStart: BFCM_POSTBF_START,
    bfcmPostBfEnd: BFCM_POSTBF_END,

    // CM Promo Week (Monday)
    bfcmCmStart: BFCM_CM_START,
    bfcmCmEnd: BFCM_CM_END,
  },

  getters: {
    getBfcmDateNow: (state) => {
      if (state.bfcmDateNow) return state.bfcmDateNow;
      return new Date().getTime();
    },

    getBfcmDatePreStart: (state) => state.bfcmPreStart,
    getBfcmDatePreEnd: (state) => state.bfcmPreEnd,

    getBfcmDateBfStart: (state) => state.bfcmBfStart,
    getBfcmDateBfEnd: (state) => state.bfcmBfEnd,

    getBfcmDatePostBfStart: (state) => state.bfcmPostBfStart,
    getBfcmDatePostBfEnd: (state) => state.bfcmPostBfEnd,

    getBfcmDateCmStart: (state) => state.bfcmCmStart,
    getBfcmDateCmEnd: (state) => state.bfcmCmEnd,
  },

  mutations: {
    SET_BFCM_DATE_NOW: (state, payload) => (state.bfcmDateNow = payload),
  },
};
